// Hooks / Node modules / Styles
import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import { ThemeSwitch, Button, useIsMobile } from "elseware-ui";

// Reducers / Actions

// Utils / Functions

// Components

// Sub-Components

// Data / Images / Icons

function UserLogPortal() {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  return (
    <div
      className={classNames({
        "flex  gap-2 items-center": true,
        "flex-row": !isMobile,
        "flex-col pt-5 px-3": isMobile,
      })}
    >
      {isMobile ? (
        <div className="flex flex-row items-center justify-center gap-5 border border-gray-500/50 w-full p-2 rounded-lg">
          <div className="dark:text-gray-400">Toggle Theme</div>
          <ThemeSwitch />
        </div>
      ) : (
        <ThemeSwitch />
      )}
      <Button
        variant="success"
        text="Contact"
        size="small"
        styles="text-sm h-8 px-3"
        shape="softRoundedSquare"
        ghost
        block={isMobile}
        onClick={() => navigate("/contact")}
      />
      {/* <Button
        variant="success"
        text="Log In"
        size="small"
        styles="text-sm h-8 px-3"
        shape="softRoundedSquare"
        ghost
        block={isMobile}
        onClick={() => navigate("/login")}
      />
      <Button
        variant="success"
        text="Sign Up"
        size="small"
        styles="text-sm h-8 px-3"
        shape="softRoundedSquare"
        block={isMobile}
        onClick={() => navigate("/signup")}
      /> */}
    </div>
  );
}

export default UserLogPortal;
